import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import reducers from './rootReducer'
import { composeWithDevTools } from 'redux-devtools-extension'
import { log } from '../../helpers/logger'

export default function configureStore (container) {
  const store = createStore(
    reducers,
    composeWithDevTools(
      applyMiddleware(
        thunkMiddleware.withExtraArgument(container)
      )
    )
  )

  store.subscribe(() => {
    log('store', store.getState())
  })

  return store
}